import { cn } from '@/lib/utils'
import BackgroundAudio from '../BackgroundAudio'
import AccountButton from './AccountButton'
import FollowingButton from './FollowingButton'
import ConversationsButton from './ConversationsButton'
import NotificationsButton from './NotificationsButton'
import RelayFeedButton from './RelayFeedButton'

export default function BottomNavigationBar() {
  return (
    <div
      className={cn(
        'fixed bottom-0 w-full z-40 bg-background border-t pb-[env(safe-area-inset-bottom)]'
      )}
    >
      <BackgroundAudio className="rounded-none border-x-0 border-t-0 border-b bg-background" />
      <div className="w-full flex justify-center items-center gap-1 px-2 [&_svg]:size-4 [&_svg]:shrink-0">
        <FollowingButton />
        <RelayFeedButton />
        <ConversationsButton />
        <NotificationsButton />
        <AccountButton />
      </div>
    </div>
  )
}
